import { injectHttpUIEffect } from "~/lib/httpUIEffect/index";
import { watchAccessToken, getStoreModuleContext } from "~/utils/store";

function prefillStore() {
  const customerNameStore = getStoreModuleContext("customerName");
  const userProfileDetailsStore = getStoreModuleContext("userProfileDetails");

  const { dataloader } = injectHttpUIEffect(this.app);

  if (!customerNameStore.state.responseData)
    customerNameStore.dispatch("fetchData", { dataloader });

  if (!userProfileDetailsStore.state.responseData)
    userProfileDetailsStore.dispatch("fetchData", { dataloader });
}

export default function (app) {
  watchAccessToken(
    prefillStore.bind({
      app,
    })
  );
}
